import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Dropdown, NavDropdown } from "react-bootstrap";
import { DropdownSubmenu, NavDropdownMenu } from "react-bootstrap-submenu";
import { useDispatch, useSelector } from "react-redux";
import { startLogout } from "../../app/actions/authActions";
import register from "../../resources/images/user-dropdown/register-svgrepo-com.svg";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { userCleanSaved, userStartSavePreferences } from "../../app/actions/userActions";
import { cleanUserRoleSelected } from "../../app/actions/userRoleActions";


import { cleanSearchParams } from "../../app/actions/searchHistoryActions";
import { isDocumentationWikiEnabled } from "../../app/helpers/documentationWikiConfigHelper";
import { buildNavigationForUser } from "../../app/helpers/documentationWikiHelper";
import { activeLanguageCode, enabledLanguageOptions, parseEnabledLanguages } from "../../app/helpers/uiLanguagesHelper";
import LanguageFlag from "../generic-component/LanguageFlag";

const DropdownUser = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { isUserAuthenticated, user } = useSelector((state) => state.auth);
  const { roleLogin } = useSelector((state) => state.userRole);
  const configurationState = useSelector((state) => state.configuration);
  const languageOptions = enabledLanguageOptions(configurationState?.uiLanguagesEnabled);
  const activeCode = activeLanguageCode(i18next.resolvedLanguage || i18next.language);
  const currentLanguage = languageOptions.find((option) => option.code === activeCode) || languageOptions[0];
  const wikiEnabled = isDocumentationWikiEnabled(configurationState);
  const documentationMenuVisible = wikiEnabled
    && buildNavigationForUser(roleLogin || {}, configurationState).length > 0;

  const handleOnClickLogout = () => {
    dispatch(startLogout());
    //JT limpio busqueda anterior
    dispatch(cleanSearchParams());
    dispatch(cleanUserRoleSelected());
    
     navigate("/login");
  };

  const handleOnClickLogin = () => {
    
    navigate("/login");
  };

  const handleOnClickPreferences = () => {
    
    navigate("/end-user");
  };

  const handleOnClickDocumentation = () => {
    navigate("/documentation");
  };

  const handleClickRegister = () => {
    dispatch(userCleanSaved());
    navigate("/sign-up");
  };

  useEffect(() => {
    const enabled = parseEnabledLanguages(configurationState?.uiLanguagesEnabled);
    const active = activeLanguageCode(i18next.resolvedLanguage || i18next.language);
    if (!enabled.includes(active)) {
      i18next.changeLanguage(enabled[0]);
    }
  }, [configurationState?.uiLanguagesEnabled]);

  const handleClickSelectLanguage = (event, lang) => {
    if (event && event.preventDefault) event.preventDefault();
    i18next.changeLanguage(lang);
    if (isUserAuthenticated) {
      dispatch(userStartSavePreferences({ language: lang }));
    }
  }

  const getLanguageSelected = () => {
    return (
      <span className="language-menu-row">
        <i className="fa fa-globe"></i>
        {t("general.language")}
        <LanguageFlag code={currentLanguage?.code} size={18} />
      </span>
    )
  }

  return (
    <NavDropdownMenu
      className="btn-dropdown-circle btn-nav-dropdown-menu"
      
      title={
        <span>
          {isUserAuthenticated ? (
            <Dropdown.Toggle>
              <i className="fa fa-user"></i>
            </Dropdown.Toggle>
          ) : (
            <Dropdown.Toggle>
              <i className="fa fa-user-slash"></i>
            </Dropdown.Toggle>
          )}
        </span>}

      id="collasible-nav-dropdown"
    >

      <NavDropdown.Item>
        {isUserAuthenticated ? (
          <Dropdown.Item>
            <span> {t("general.welcome")}: </span>
            {user.first_name} {user.last_name}
          </Dropdown.Item>
        ) : (
          <Dropdown.Item onClick={handleClickRegister}>
            <img src={register} alt="" width={40}></img>
            {t("login.register")}
          </Dropdown.Item>
        )}
      </NavDropdown.Item>

      {isUserAuthenticated && (
        <NavDropdown.Item>
          <Dropdown.Item onClick={handleOnClickPreferences} style={{ fontSize: "1.5rem" }}>
              <i className={`fa fa-regular fa-user`}></i> {t("general.preferences")}
              {/*<img src={login} alt="" width={44}></img> {t("general.preferences")}*/}
            </Dropdown.Item>
        </NavDropdown.Item>
      )}

      {isUserAuthenticated && documentationMenuVisible && (
        <Dropdown.Item onClick={handleOnClickDocumentation} style={{ fontSize: "1.5rem" }}>
          <i className="fa fa-book" /> {t("docs.menuLabel")}
        </Dropdown.Item>
      )}

      <NavDropdown.Divider />

      <DropdownSubmenu title={getLanguageSelected()} className="button-nav-dropdown-icon">
        {languageOptions.map((option) => (
          <NavDropdown.Item key={option.code} onClick={(event) => handleClickSelectLanguage(event, option.code)}>
            <span className="language-menu-row">
              {option.label}
              <LanguageFlag code={option.code} size={18} />
            </span>
          </NavDropdown.Item>
        ))}
      </DropdownSubmenu>

      <NavDropdown.Divider />

      <NavDropdown.Item>
        {isUserAuthenticated ? (
          <div>
            <Dropdown.Item onClick={handleOnClickLogout} style={{ fontSize: "2rem" }}>
              <i className={`fas fa-sign-out-alt`}></i> {t("login.logout")}
            </Dropdown.Item>
          </div>
        ) : (
          <div>
            <Dropdown.Item onClick={handleOnClickLogin} style={{ fontSize: "2rem" }}>
              <i className={`fas fa-sign-in-alt`}></i> {t("login.login")}
            </Dropdown.Item>
          </div>
        )}
      </NavDropdown.Item>

    </NavDropdownMenu>
  );
};

export default DropdownUser;
